/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */

/**
 * The updated account type to assign to the user in the organization.
 */
export type UpdateUserRequestDtoAccountType = typeof UpdateUserRequestDtoAccountType[keyof typeof UpdateUserRequestDtoAccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUserRequestDtoAccountType = {
  admin: 'admin',
  basic_user: 'basic_user',
} as const;
